import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurPhiladelphia = () => (
  <SEOPageTemplate
    city="Philadelphia"
    state="PA"
    route="/chauffeur-philadelphia-pa"
    imageSrc="/philadelphia-limo.jpg"
    introduction="In Philadelphia, where history meets innovation, TiLimousine provides a transportation service that bridges the city's rich heritage with modern business needs. Our chauffeurs are intimately familiar with Philadelphia's unique grid system, from the historic streets of Old City to the bustling business districts of Center City. Whether you're attending a conference at the Convention Center, visiting the Liberty Bell, or heading to a business meeting in University City, our service ensures you arrive with the elegance and efficiency that Philadelphia deserves."
    testimonial={{
      quote: "As a pharmaceutical executive, I frequently travel between our offices in University City and meetings in Center City. TiLimousine's chauffeurs understand the importance of timing in our industry. Their knowledge of Philadelphia's streets and traffic patterns has been crucial for my business.",
      author: "Sarah L.",
      role: "Director of Clinical Operations, Philadelphia Pharma"
    }}
    fboLink={{
      url: "https://signatureflight.com/locations/philadelphia",
      name: "Signature Aviation – Philadelphia International"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Philadelphia ⇄ NYC, Philadelphia ⇄ DC',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Philadelphia',
      'Best chauffeur in Pennsylvania',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Philadelphia',
      'Best executive car service in Philadelphia',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Philadelphia International Airport (PHL)',
      'Northeast Philadelphia Airport (PNE)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA',
      'Baltimore/Washington International (BWI)'
    ]}
    neighborhoods={[
      'Center City',
      'University City',
      'Old City',
      'Rittenhouse Square',
      'Society Hill',
      'Fishtown',
      'Northern Liberties',
      'Navy Yard',
      'Manayunk',
      'King of Prussia',
      'Conshohocken',
      'Greater Philadelphia Area'
    ]}
  />
);

export default ChauffeurPhiladelphia; 